<template>
  <div class="wrapper">
    <div class="contentBox">
      <div class="searchBar">
        <el-input
          class="searchInput"
          size="small"
          placeholder="论文名称"
          v-model="searchCondition.paperName"
          clearable
        >
        </el-input
        >&emsp;
        <el-select
          width="20px"
          v-model="searchCondition.reviewStatus"
          placeholder="审核状态"
          size="small"
        >
          <el-option
            v-for="item in reviewOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option> </el-select
        >&emsp;
        <el-input
          class="searchInput"
          size="small"
          placeholder="提交时间"
          v-model="searchCondition.createTime"
          clearable
        >
        </el-input
        >&emsp;
        <el-input
          class="searchInput"
          size="small"
          placeholder="审核人"
          v-model="searchCondition.auditTeacher"
          clearable
        >
        </el-input
        >&emsp;
        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          @click="getPaperReviewList()"
          >查询
        </el-button>
        <el-button
          type="info"
          size="small"
          icon="el-icon-refresh-right"
          @click="getPaperReviewList()"
          >重置
        </el-button>
      </div>

      <div class="tableContainer">
        <div class="actionBar">
          <el-button plain @click="exportData"> 导出 </el-button>&emsp;

          <el-button plain @click="dialogVisible = true" accept=".xls,.xlsx">
            导入 </el-button
          >&emsp;
          <el-button
            class="reviewBar"
            type="primary"
            size="small"
            @click="reviewBatchPaper(1)"
            >审核通过
          </el-button>
          <el-button
            class="reviewBar"
            type="primary"
            size="small"
            @click="reviewBatchPaper(0)"
            >审核不通过
          </el-button>
        </div>
        <Table
          :columns="columns"
          :data="paperReviewList"
          border
          @on-selection-change="choosenChange"
        >
          <template slot-scope="{ row, index }" slot="action">
            <div>
              <el-button plain size="mini" class="bluBar" @click="pdfShow(row)"
                >预览
              </el-button>
              <el-button
                size="mini"
                class="bluBar"
                @click="goToDetail('thesisAudit', row, 1)"
                >审核
              </el-button>
              <el-button size="mini" class="bluBar" @click="download(row)"
                >下载
              </el-button>
            </div>
          </template>
        </Table>

        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="40%"
          append-to-body
          @closed="reset()"
        >
          <el-form>
            <el-form-item label="模板说明">
              <el-tag type="info"
                >excel模版说明:批量更新审核状态，需按照此模板填写，不要改变原始样式</el-tag
              >
            </el-form-item>
            <el-form-item label="模板下载">
              <el-tag>
                <i class="el-icon-download" />
                <!-- 这里的话可以把这个模板放到阿里的OSS中 这个地方是采用放入项目中-->
                <a :href="downloadUrl" icon="md-album">点击下载模板</a>
              </el-tag>
            </el-form-item>
            <el-form-item label="上传文件">
              <el-upload
                ref="upload"
                :auto-upload="false"
                :on-change="fileChange"
                :on-exceed="exceedFile"
                :on-success="handleSuccess"
                :on-error="handleError"
                :http-request="uploadPaper"
                :limit="1"
                :headers="{ Authorization: getStore('accessToken') }"
                action="/bpi/paper-setting/v1/excel/excelImport"
                name="file"
                accept=".xls,.xlsx"
                :file-list="fileList"
              >
                <el-button size="small" plain>选择文件</el-button>
                &emsp;!只能上传xls/xlsx文件
              </el-upload>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="importData()">确 定</el-button>
          </span>
        </el-dialog>

        <!--分页-->

        <el-row>
          <el-col :span="24">
            <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="paginations.page_index"
                :page-sizes="paginations.page_sizes"
                :page-size.sync="paginations.page_size"
                :layout="paginations.layout"
                :total="paginations.total"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      title="论文预览"
      :visible.sync="pdfData.pdfIfShow"
      width="70%"
      :append-to-body="true"
      top="2vh"
      :destroy-on-close="true"
      ><pdf
        v-if="pdfData.pdfIfShow"
        :src="pdfData.pdfStream"
        :page="pdfData.currentPage"
        @num-pages="pdfData.totalPage = $event"
      ></pdf>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <el-button size="small" @click="pdfData.pdfIfShow = false"
          >关闭</el-button
        >
        <el-button
          size="small"
          type="primary"
          plain
          @click="pdfData.currentPage--"
          v-show="pdfData.currentPage > 1"
          >上一页</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="pdfData.currentPage++"
          v-show="pdfData.currentPage < pdfData.totalPage"
          >下一页</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPaperReviewList,
  reviewBatchPaper,
  paperReviewExcelImport,
  paperReviewExcelExport,
} from "@/api/paper.js";
import FileSave from "file-saver";
import pdf from "vue-pdf";
export default {
  data() {
    return {
      pdfData: {
        pdfUrl: null,
        pdfIfShow: false,
        currentPage: 1,
        totalPage: 0,
        pdfStream: null,
      },
      downloadUrl: "../审核状态导入模板.xlsx",
      dialogVisible: false,
      fileList: [],
      paginations: {
        page_index: 1, //当前页
        page_size: 30, //每页多少条
        total: 30,
        page_sizes: [10, 15, 30, 50],
        layout: "sizes, prev, pager, next,jumper",
      },
      searchCondition: {
        pageSize: 30,
        jumpPage: 1,
        paperGroupName: "",
        reviewStatus: "",
        createTime: "",
        auditTeacher: "",
        paperName: "",
        ids: [],
      },
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
          key: "choose",
        },
        {
          title: "考试名称",
          key: "testName",
        },

        {
          title: "论文分组",
          key: "paperGroupName",
        },
        {
          title: "论文名称",
          key: "paperName",
        },
        {
          title: "提交人",
          key: "userName",
        },
        {
          title: "手机号",
          key: "paperGroupName",
        },
        {
          title: "提交次数",
          key: "submitNum",
        },
        {
          title: "审核状态",
          key: "reviewStatus",
        },
        {
          title: "审核人员",
          key: "auditTeacher",
        },
        {
          title: "提交时间",
          key: "createTime",
        },
        {
          title: "操作",
          slot: "action",
          width: 160,
          align: "center",
        },
      ],
      paperReviewList: [],
      reviewOptions: [
        {
          value: 0,
          label: "审核不通过",
        },
        {
          value: 1,
          label: "审核通过",
        },
        {
          value: 2,
          label: "待审核",
        },
      ],
    };
  },
  components: { pdf },
  created() {},
  mounted() {
    this.getPaperReviewList();
  },
  methods: {
    pdfShow(row) {
      var loadingTask = pdf.createLoadingTask(row.paperUrl);
      this.pdfData.pdfIfShow = true;
      this.pdfData.pdfStream = loadingTask;
      console.log(loadingTask);
    },

    handleSizeChange(page_size) {
      console.log(`每页 ${page_size} 条`);
      this.paginations.page_size = page_size;
      this.searchCondition.pageSize = page_size;
      this.getPaperSettingList();
    },
    handleCurrentChange(page) {
      console.log(`当前页: ${page}`);
      this.paginations.page_index = page;
      this.searchCondition.jumpPage = page;
      this.getPaperSettingList();
    },

    goToDetail(routerName, item, e) {
      this.$router.push({
        name: routerName,
        query: { id: item.id, userId: item.userId, type: e },
      });
    },
    download(row) {
      var oReq = new XMLHttpRequest();
      oReq.open("GET", row.paperUrl, true);
      oReq.responseType = "blob";
      oReq.onload = function () {
        var file = new Blob([oReq.response], {
          type: "application/pdf",
        });
        FileSave.saveAs(file, row.paperName + ".pdf");
      };
      oReq.send();
    },
    getPaperReviewList() {
      console.log("筛选条件searchCondition=", this.searchCondition);
      getPaperReviewList(this.searchCondition).then((data) => {
        console.log("paperSettingList结果", data);
        this.paperReviewList = data.records;
        this.paginations.total = data.total;
      });
    },

    choosenChange(selection) {
      this.searchCondition.ids = selection;
      console.log("打勾的", this.searchCondition.ids);
    },

    reviewBatchPaper(e) {
      this.$Modal.confirm({
        title: "批量审核",
        content: "<p>正在进行批量审核,请您谨慎操作</p>",
        onOk: () => {
          // let ids = this.searchCondition.ids.reduce((total, item) => {
          //   total.push({id: String(item.id), userId: String(item.userId)});
          //   return total;
          // }, []);
          let ids = this.searchCondition.ids.reduce((total, item) => {
            total.push(item.id);
            return total;
          }, []);

          console.log("批量的ids", ids, e);
          reviewBatchPaper({ ids: ids, reviewStatus: e }).then((data) => {
            this.$Message.success("批量操作成功");
            this.getPaperReviewList();
          });
        },
        onCancel: () => {
          this.$Message.info("批量操作已取消");
        },
      });
    },

    exportData() {
      let idList = this.searchCondition.ids.reduce((total, item) => {
        total.push(item.id);
        return total;
      }, []);
      this.searchCondition.ids = idList;
      console.log("aaaaaa", this.searchCondition.ids);
      console.log("jiiiiiiiiiiiiiiiii");
      paperReviewExcelExport(this.searchCondition)
        .then((data) => {
          console.log("来咯", data);
          this.$message.success("上传成功!");
          const pdfUrl = window.URL.createObjectURL(
            new Blob([data], {
              type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
            })
          );
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.setAttribute("download", "论文查重审核列表.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    uploadPaper(e) {
      console.log("aaaaaa");
      let formData = new FormData();
      formData.append("file", e.file);
      console.log("jiiiiiiiiiiiiiiiii");
      paperReviewExcelImport(formData)
        .then((data) => {
          console.log("来咯", data);
          this.$message.success("上传成功!");
          const pdfUrl = window.URL.createObjectURL(
            new Blob([data], {
              type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
            })
          );
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.setAttribute("download", "更新查重状态失败列表.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    importData() {
      if (this.$refs.upload) {
        this.$refs.upload.submit();
        this.dialogVisible = false;
      } else {
        console.error("未找到upload控件");
      }
    },

    //重置 upload文件
    reset() {
      this.$refs.upload = null;
    },

    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$notify.error({
        title: "错误",
        message: "只能上传一个文件哦",
      });
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      console.log("file00000", file);
      if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
        this.$notify.error({
          title: "错误",
          message: "上传文件只能为excel文件，且为xlsx,xls格式",
        });
        this.fileList = [];
        this.file = "";
        return false;
      }
      this.file = file.raw;
      this.filename = file.name;
    },

    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      console.log("before upload");
      console.log(file);
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== "xlsx") {
        this.$notify.warning({
          title: "警告",
          message: `只能上传后缀是(.xlsx或者.xls）的文件`,
        });
      }
      if (size > 10) {
        this.$notify.warning({
          title: "警告",
          message: `文件大小不得超过10M`,
        });
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      let blob = new Blob([JSON.stringify(res)], { type: "application/json" });
      // console.log('blob', blob)
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = "change_" + file.name;
      a.click();
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: "错误",
        message: `文件上传失败`,
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  font-size: 12px;

  .contentBox {
    padding: 20px;

    .searchBar {
      background: #fff;
      padding: 20px;
      margin-bottom: 15px;

      .searchInput {
        width: 20%;
      }
    }

    //.lineStyle {
    //  overflow: scroll;
    //  width: 100%;
    //}

    .tableContainer {
      background: #fff;
      padding: 20px;

      .actionBar {
        padding-bottom: 10px;

        .reviewBar {
          float: right;
        }
      }

      .bluBar {
        width: auto;
        color: #36aafd;
        border: 1px solid #36aafd;
        padding: 7px 10px;
        border-radius: 4px !important;
      }
    }
  }
}
</style>
